import { camelToSnakeCase } from "@util/strings";

// Legacy round ups have data attrs on them already with some company props
// e.g. data-company-id="1", we need to pull these data attrs off and format them
// the same way all other oskar data attrs are formatted so they'll all be picked up
// when we 'initOskarTriggers'

export const addPropsToLegacyRoundups = async () => {
    const elements = Array.from(document.querySelectorAll(".company-round-up"));
    elements.forEach(element => {
        if (!(element instanceof HTMLElement)) {
            return;
        }
        const eventProps: { [key: string]: any } = {};
        Object.keys(element.dataset).forEach(key => {
            let value: string | number = element.dataset[key];
            if (key === "companyId" || key === "companyOrderNum") {
                value = parseInt(value, 10);
            }
            eventProps[camelToSnakeCase(key)] = value;
        });
        element.dataset.oskarProps = JSON.stringify(eventProps);
        element.dataset.oskarClick = "adviceCompanyModuleClicked";
        element.dataset.oskarView = "adviceCompanyModuleViewed";
    });
};
